var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#A4AAC4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.863 8.343h-1.1V4.558c0-1.411-1.13-2.558-2.521-2.558H2.52C1.13 2 0 3.147 0 4.558v10.333c0 1.411 1.13 2.558 2.52 2.558h6.977v1.756H7.36c-.487 0-.885.404-.885.897 0 .494.398.898.885.898h6.048c.486 0 .884-.404.884-.898 0-.493-.398-.897-.884-.897H11.27v-1.756h1.975c.487 0 .885-.404.885-.897 0-.494-.398-.898-.885-.898H2.52c-.412 0-.751-.339-.751-.763V4.558c0-.419.334-.763.751-.763h15.722c.413 0 .752.34.752.763v3.785h-1.1c-1.18 0-2.138.973-2.138 2.17v8.318c0 1.197.958 2.169 2.137 2.169h3.975c.486 0 .884-.404.884-.898 0-.493-.398-.897-.884-.897h-3.975c-.201 0-.368-.165-.368-.374v-8.318c0-.205.162-.374.368-.374h3.975c.201 0 .368.164.368.374v6.278c0 .494.398.898.885.898.486 0 .879-.404.879-.898v-6.278c0-1.197-.958-2.17-2.137-2.17z",
    transform: "translate(-40.000000, -160.000000) translate(0.000000, 88.000000) translate(0.000000, 56.000000) translate(40.000000, 16.000000)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevices);
export default __webpack_public_path__ + "static/media/devices.88c8dad90364ea04db2cd956fb32df24.svg";
export { ForwardRef as ReactComponent };